import { InterceptType } from '../../../__generated__/fed-graphql-types'
import { InterceptContent } from './use-intercept.hook'
import { PictogramRelevanceSearch } from '@at/design-system-pictograms'
import React from 'react'
import { getInterceptStorage, setInterceptStorage } from '../../search-listings/intercept.util'

// This type structure will be stored in local storage therefore removing any properties will be a breaking change
export type RelevanceSearchIntercept = {
    sort: string
}

function relevanceMatches(relevanceInterceptData: RelevanceSearchIntercept[], sortParam: string) {
    return relevanceInterceptData.some((item) => item.sort === sortParam)
}

export const shouldShowRelevanceIntercept = (sortParam: string | undefined) => {
    const relevanceInterceptData = getInterceptStorage(InterceptType.RELEVANCE_SEARCH)
    if (relevanceInterceptData && sortParam) {
        return !relevanceMatches(relevanceInterceptData, sortParam)
    }
    return true
}

export const getRelevanceInterceptContent = (
    position: number,
    updatedSort: string | null,
    updateSortBySelected: (sort: string | null, shouldUpdateUrl?: boolean) => void,
    sortBySelected: string | undefined
): InterceptContent => {
    const shouldUpdateLocalStorageForRelevanceSearch = (previousSearches: RelevanceSearchIntercept[] | undefined) => {
        if (previousSearches === undefined) return true
        return !relevanceMatches(previousSearches, sortBySelected ?? '')
    }

    const updateRelevanceSearchInterceptLocalStorage = () => {
        const currentIntercept: RelevanceSearchIntercept[] | undefined = getInterceptStorage(
            InterceptType.RELEVANCE_SEARCH
        )
        if (shouldUpdateLocalStorageForRelevanceSearch(currentIntercept) && sortBySelected) {
            setInterceptStorage(InterceptType.RELEVANCE_SEARCH, { sort: sortBySelected })
        }
    }

    return {
        pictogram: <PictogramRelevanceSearch title={'Relevance intercept'} />,
        trackingLabel: 'intercept-relevance',
        componentNameLabel: `search-intercept-relevance-${position}`,
        handleClick: () => {
            updateRelevanceSearchInterceptLocalStorage()
            updateSortBySelected(updatedSort)
            window.scrollTo({ top: 0, left: 0, behavior: `instant` })
        },
    }
}
